import { Member } from 'core/interface/MemberAccount';

const Ashley: Member = {
	party_type_id: 'dummy',
	customer_reference_number: '31075195',
	salutation: 'MS',
	first_name: 'Ashley',
	last_name: 'Doe',
	birth_date: '1975-10-11',
	date_of_death: '2020-10-11',
	classification_id: '700',
	first_web_portal_login: true,
	age: 74,
	email_address: 'ashley.doe@email.com',
	member_status: '',
	gender: '',
	profile_actions: {
		review_your_personal_details: true,
		add_your_mobile_number: true,
		manage_your_beneficiaries: false,
		communication_preference: false,
		tell_your_employer_last_updated_date: '2022-03-26',
		consolidate_your_super_last_updated_date: '2022-03-26',
		make_contribution_last_updated_date: '2022-03-26',
	},
	accounts: [
		{
			account_number: '700069092',
			product_name: 'Accumulation',
			product_classification: 'Accumulation',
			account_status: 'ACTIVE',
			joined_date: '2007-07-08',
		},
		{
			account_number: '700069093',
			product_name: 'Pension',
			product_classification: 'TTR',
			account_status: 'ACTIVE',
			joined_date: '2006-07-08',
		},
		{
			account_number: '700069091',
			product_name: 'Pension',
			product_classification: 'Pension',
			account_status: 'ACTIVE',
			joined_date: '2008-07-08',
		},
	],
	phone_numbers: [
		{
			type: 'MOBILE',

			number: '432765981',
		},
		{
			type: 'HOME',

			number: '80329584',
		},
		{ type: 'WORK', number: '52767676' },
	],
	addresses: [
		{
			type: 'RESIDENTIAL',
			address_line1: '50 Lonsdale Street',
			address_line2: '',
			postcode: '3000',
			city: 'Melbourne',
			state: 'VIC',
			country: 'Australia',
			status: 'active',
		},
		{
			type: 'POSTAL',
			address_line1: '50 Lonsdale Street Postal',
			address_line2: '',
			postcode: '3000',
			city: 'Melbourne',
			state: 'VIC',
			country: 'Australia',
			status: 'active',
		},
	],
};

export default Ashley;
